import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AuditResourceTypesFetchFailedAction = {
	type: 'AUDIT_RESOURCE_TYPES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AuditResourceTypesFetchFailedAction => ({
	type: 'AUDIT_RESOURCE_TYPES_FETCH_FAILED',
	payload,
});
